import * as React from 'react';

function SvgTuts(props) {
  return (
    <svg width={56} height={56} fill="none" viewBox="0 0 56 56" {...props}>
      <circle cx={28} cy={28} r={28} fill="#242A35" />
      <path
        fill="#fff"
        d="M31.3333 12V18.8182H38L31.3333 12ZM29.6667 18.8182V12H20.5C19.1193 12 18 13.1447 18 14.5568V36.7159C18 38.1275 19.1193 39.2727 20.5 39.2727H35.5C36.8807 39.2727 38 38.128 38 36.7159V20.5227H31.3802C30.4115 20.5227 29.6667 19.761 29.6667 18.8182ZM33.4167 29.8977C33.4167 30.604 32.8573 31.1282 32.1667 31.1282H29.25V34.1112C29.2031 34.8675 28.6927 35.4375 28 35.4375C27.3089 35.4375 26.75 34.8654 26.75 34.207V31.1282H23.7865C23.1422 31.1282 22.5833 30.6062 22.5833 29.8977C22.5833 29.1914 23.1427 28.6673 23.7865 28.6673H26.75V25.5884C26.75 24.9279 27.3073 24.358 28 24.358C28.6927 24.358 29.2031 24.93 29.2031 25.5884V28.6193H32.1667C32.8594 28.6193 33.4167 29.1893 33.4167 29.8977Z"
      />
    </svg>
  );
}

export default SvgTuts;
